export const ESTATE_SELLER_TYPE = 'EstateSeller'
export const ADDITIONAL_ESTATE_SELLER_TYPE = 'AdditionalEstateSeller'
export const ESTATE_SELLERS_LIMIT = 5
